module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/LED Logo Display Module.7e28c4c6.png";